import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';
import { CustomRoute, ReuseStrategyType } from './core/interfaces/custom-route.interface';

export class CustomReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const futureCr: CustomRoute = future.routeConfig as CustomRoute;
    const currentCr: CustomRoute = curr.routeConfig as CustomRoute;
    let customReuse: boolean | null = this.checkCustomConditions(futureCr, currentCr);
    // Fragment navigations
    if (this.checkUrlFragments(future, curr)) {
      customReuse = null;
    }

    return customReuse ?? super.shouldReuseRoute(future, curr);
  }

  private checkCustomConditions(future: CustomRoute, curr: CustomRoute): boolean | null {
    if (
      future == null ||
      future.hasOwnProperty('shouldReuse') == false ||
      future.shouldReuse == null ||
      future.shouldReuse == ReuseStrategyType.default
    ) {
      return null;
    }

    if (future.shouldReuse == ReuseStrategyType.always) {
      return true;
    }

    if (future.shouldReuse == ReuseStrategyType.never) {
      return false;
    }

    if (future.shouldReuse == ReuseStrategyType.onDiffRoutes) {
      return this.onDiffRoutesStrategy(future, curr);
    }

    if (future.shouldReuse == ReuseStrategyType.onSameRoutes) {
      return this.onSameRoutesStrategy(future, curr);
    }

    return null;
  }

  private onDiffRoutesStrategy(future: CustomRoute, curr: CustomRoute): boolean {
    return future !== curr;
  }

  private onSameRoutesStrategy(future: CustomRoute, curr: CustomRoute): boolean {
    return future === curr;
  }

  private checkUrlFragments(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future == null || curr == null) {
      return false;
    }

    // FIXME: we should check if the url is the same
    if (future.fragment !== null && future.fragment.length > 0) {
      return true;
    }

    return false;
  }
}
